module.exports = __webpack_public_path__ + "assets/img/vuex_actions.631fbdd6.jpg";